import { toast } from "react-toastify";


export default function successMsg(msg) {
    return toast.success(msg, {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "light",
      style: {
          // Apply custom styles
          minWidth: '250px',
          textAlign: 'center',
        },
      });
}